import { EXAMINATION_CENTERS_ERROR, GETTING_EXAMINATION_CENTERS, GET_EXAMINATION_CENTERS } from "../types"

const initialState = {
    examinationCenters: [],
    loadingExaminationCenters: true,
    examinationCentersError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_EXAMINATION_CENTERS:
        return {
            ...state,
            loadingExaminationCenters :action.payload,
        }
        case GET_EXAMINATION_CENTERS:
        return{
            ...state,
            loadingExaminationCenters:false,
            examinationCentersError:  null,
            examinationCenters: action.payload,
        }
        case EXAMINATION_CENTERS_ERROR:
        return{
            ...state,
            loadingExaminationCenters:false,
            creatingExaminationCenter:false,
            updatingExaminationCenter:false,
            examinationCenters: action.payload 
        }
        default: return state
    }

}